// src/Pages/PrintGallerySection.jsx

import React, { useEffect } from "react";
import "../../Style/PrintGallerySection.css";
import { myCustomTheme } from "../../Theme.jsx";

import img1 from "../../Assets/GallerySection-1.jpg";
import img2 from "../../Assets/GallerySection-2.jpg";
import img3 from "../../Assets/GallerySection-3.jpg";
import img4 from "../../Assets/GallerySection-4.jpg";
import img5 from "../../Assets/GallerySection-5.jpg";
import img6 from "../../Assets/GallerySection-6.jpg";
import img7 from "../../Assets/GallerySection-7.jpg";
import img8 from "../../Assets/GallerySection-8.jpg";

import "swiper/css";

const galleryData = [
  {
    id: 1,
    title: "Green Owl",
    description:
      "Aliquam pellentesque est orci, viverra sodales est congue ut praesent.",
    image: img1,
    className: "top-box",
  },
  {
    id: 2,
    title: "3D Skull",
    description:
      "Modern layered skull printing with detailed texture finish.",
    image: img2,
    className: "top-box",
  },
  {
    id: 3,
    title: "Polygon Vase",
    description:
      "Creative geometric vase created using advanced 3D printing.",
    image: img3,
    className: "top-box",
  },
  {
    id: 4,
    title: "Drone Frame",
    description:
      "Lightweight custom drone frame prototype for engineering.",
    image: img4,
    className: "bottom-box",
  },
  {
    id: 5,
    title: "Twist Sculpture",
    description:
      "Elegant spiral decorative structure with smooth curves.",
    image: img5,
    className: "bottom-box",
  },
  {
    id: 6,
    title: "Turbofan Prototype",
    description: "Aerospace engine 3D modeling with blade simulation.",
    image: img6,
    className: "top-box",
  },
  {
    id: 7,
    title: "Robotic Arm Design",
    description: "Multi-axis industrial robotic arm with modular gripper.",
    image: img7,
    className: "top-box",
  },
  {
    id: 8,
    title: "Mechanical Prototyping",
    description: "3D printed mechanical parts with joints and linkages.",
    image: img8,
    className: "top-box",
  },
];

const PrintGallerySection = () => {

  // ✅ OPEN ANIMATION
  useEffect(() => {
    const section = document.querySelector(".print-gallery-section");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.2 }
    );

    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  return (
    <section
      className="print-gallery-section"
    >
      <div className="print-gallery-container">
        {galleryData.map((item, index) => (
          <div
            key={item.id}
            className={`print-gallery-card ${item.className}`}
            style={{
              borderRadius: myCustomTheme.spacing.border_radius,
              boxShadow: myCustomTheme.shadows.soft,
              animationDelay: `${index * 0.2}s`,
            }}
          >
            <img src={item.image} alt={item.title} />

            <div className="print-gallery-overlay">
              <h2
                style={{
                  color: myCustomTheme.colors.button_text,
                  fontFamily:
                    myCustomTheme.typography.heading_font,
                }}
              >
                {item.title}
              </h2>

              <p
                style={{
                  color: myCustomTheme.colors.p_text,
                  fontFamily:
                    myCustomTheme.typography.text_font,
                }}
              >
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PrintGallerySection;